'use strict';

import React from 'react';
import Utils from './Utils'
import DownloadComponent from './DownloadComponent';
require('styles//Snippet.css');

class SnippetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      css: ">"
    }

  }

  componentWillReceiveProps(props) {

  }


  render() {
    const hidden = this.props.hidden;

    const object = this.props.data;
    let result = {};

    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        const element = object[key];
        const selector = element.selector;

        if ('individual' != element.individual) {
          continue;
        }

        if (!result[selector]) {
          result[selector] = Utils.transformCSS(element);
        }
        else {
          result[selector] = result[selector] + Utils.transformCSS(element);
        }
      }
    }

    const output = this.props.hidden === 'individual' ? Utils.generateCSS(result) : Utils.generateTheme(object);

    return (
      <div className="py-3">
      <p className="lead py-3">Here the integration steps</p>
        <div className="">
          <div className="fakeMenu">
            <div className="fakeButtons fakeClose"></div>
            <div className="fakeButtons fakeMinimize"></div>
            <div className="fakeButtons fakeZoom"></div>
          </div>
          <div className="fakeScreen">
            <p className="line4" dangerouslySetInnerHTML={{__html:output}}></p>
          </div>
            { this.props.hidden === 'individual' ? 
              <ul className="py-3">
                <li className="py-1">Download  <DownloadComponent data={this.state.colorPickerState} /></li>
                <li className="py-1">Now add the file into your project path, something like:<mark><code> ~/styles/skin.css</code></mark></li>
                <li className="py-1">Now add as a new reference resource <code>.css</code> into your <mark>react config block</mark>.</li>
                <li className="py-1">Finally open your page and enjoy your new experience!</li>
              </ul>
              :
              <ul className="py-3">
              <li className="py-1">Please include above configuration in your <mark><code>react config block</code></mark>.</li> 
              </ul> 
            }
        </div>
      </div>
    );
  }
}

SnippetComponent.displayName = 'SnippetComponent';

// Uncomment properties you need
// SnippetComponent.propTypes = {};
// SnippetComponent.defaultProps = {};

export default SnippetComponent;
